import { $lang } from '@msdk/common'
import { GenericFieldValue } from '@msdk/definitions'
import { Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

interface Props {
  value?: GenericFieldValue
}

export function DateTimeFieldRenderer({ value }: Props) {
  const lang = useRecoilValue($lang) ?? 'en-US'
  let date = ''
  if (value) {
    const options: Intl.DateTimeFormatOptions = {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }
    const hourType = new Intl.DateTimeFormat(lang, { hour: 'numeric' }).resolvedOptions()
    if (typeof hourType.hour12 === 'boolean') {
      options.hour12 = hourType.hour12
    }
    date = new Date(value.value as string).toLocaleString(lang, options)
  }
  return <Typography variant="body1">{value ? date : '-'}</Typography>
}
